import {consts} from '../../common/modals/consts';
import {IDocumentSummaryInfo} from '../../message-models/document-summary-info.interface';
import {IDocumentSummary} from '../../message-models/document-summary.interface';
import {ILogItemDocumentSummary} from './log-item-document-summary';
import {IDateTimeWithZone} from '../../common/date-time-with-zone.interface';

export class LogItem implements ILogItem {

  constructor(iLogItem?: ILogItem) {
    this.id = iLogItem?.id || consts.emptyGuid;
    this.descriptionHtml = iLogItem?.descriptionHtml || '';
    this.logItemNumber = iLogItem?.logItemNumber || 0;
    this.loggedForEmail = iLogItem?.loggedForEmail || '';
    this.companyName = iLogItem?.companyName || '';
    this.browserDetail = iLogItem?.browserDetail || '';
    this.memberNumber = iLogItem?.memberNumber || '';
    this.officeId = iLogItem?.officeId || consts.emptyGuid;
    this.loggedByEmail = iLogItem?.loggedByEmail || '';
    this.completedBy = iLogItem?.completedBy || '';
    this.fixedInVersion = iLogItem?.fixedInVersion || '';
    this.loggedOn = iLogItem?.loggedOn || null;
    this.completionOn = iLogItem?.completionOn || null;
    this.lastStatusUpdate = iLogItem?.lastStatusUpdate || null;
    this.assignedTo = iLogItem?.assignedTo || '';
    this.itemStatus = iLogItem?.itemStatus || LogItemStatus.NotStarted;
    this.summaryInfo = iLogItem?.summaryInfo || '';
    iLogItem?.documents?.forEach(doc => this.documents?.push(doc));
    this.appRoute = iLogItem?.appRoute || '';
    this.canReproduce = iLogItem?.canReproduce || false;
    this.section = iLogItem?.section || '';

  }
  id: string;
  descriptionHtml: string;
  summaryInfo: string;
  logItemNumber: number;
  loggedForEmail: string;
  companyName: string;
  browserDetail: string;
  memberNumber: string;
  officeId: string;
  loggedByEmail: string;
  completedBy: string;
  fixedInVersion: string;
  foundInVersion: string;
  loggedOn: IDateTimeWithZone | null;
  completionOn: IDateTimeWithZone | null;
  lastStatusUpdate: IDateTimeWithZone | null;
  assignedTo: string;
  itemStatus: LogItemStatus;
  documents: ILogItemDocumentSummary[];
  appRoute: string;
  canReproduce: boolean;
  section: string;
}


export interface ILogItem {
  id: string;
  descriptionHtml: string;
  summaryInfo: string;
  logItemNumber: number;
  loggedForEmail: string;
  companyName: string;
  browserDetail: string;
  memberNumber: string;
  officeId: string;
  loggedByEmail: string;
  completedBy: string;
  fixedInVersion: string;
  foundInVersion: string;
  loggedOn: IDateTimeWithZone | null;
  completionOn: IDateTimeWithZone | null;
  lastStatusUpdate: IDateTimeWithZone | null;
  assignedTo: string;
  itemStatus: LogItemStatus;
  documents: ILogItemDocumentSummary[];
  appRoute: string;
  canReproduce: boolean;
  section: string;
}


export enum LogItemStatus {
  NotStarted,
  InProgress,
  Complete
}
export enum LogItemStatusString {
  'Not Started',
  'In Progress',
  'Complete'
}



